export const ROLES = {
  Usuario: 'usuario',
  Admin: 'admin',
}
